import { useAuth } from '@/stores/authStore';
import { useCart } from '@/stores/cartStore';
import { useFavorites } from '@/stores/favoriteStore';
import { AuthModalMode, SharedPageProps } from '@/types';
import { Head, usePage } from '@inertiajs/react';
import { ReactNode, useEffect, useRef, useState } from 'react';

interface LayoutProps {
    children: ReactNode;
}

function Layout({ children }: LayoutProps) {
    const { props, url } = usePage<SharedPageProps>();
    const {
        auth,
        authModalMode,
        nav_items,
        cart,
        cartItems,
        favorites,
        alerts,
        sharedContent,
        footer,
        seo,
    } = props;

    const { initializeAuth } = useAuth();
    const { initializeCart } = useCart();
    const { initializeFavorites } = useFavorites();

    useEffect(() => {
        initializeAuth(auth?.user, auth?.user?.shipping);
    }, [auth, initializeAuth]);

    const [currentAuthModalMode, setCurrentAuthModalMode] = useState<
        AuthModalMode | undefined
    >(authModalMode);
    const [isAuthOpen, setIsAuthOpen] = useState(!!currentAuthModalMode);

    // Инициализация корзины данными с сервера

    const isFirstRender = useRef(true);

    if (isFirstRender.current) {
        initializeCart(cart, cartItems);
    }

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        initializeCart(cart, cartItems);
    }, [cart, cartItems, initializeCart]);

    // Инициализация избранного данными с сервера
    useEffect(() => {
        if (favorites) {
            initializeFavorites(favorites);
        }
    }, [favorites, initializeFavorites]);

    return (
        <div className="flex min-h-screen flex-col bg-zinc-950 text-brand-mist selection:bg-brand-gold/30">
            <Head>
                <title>{seo?.title}</title>
                <meta
                    data-inertia
                    name="description"
                    content={`${seo?.description}`}
                />
            </Head>

            {/*<CartPortal />*/}
            {/*<Header*/}
            {/*    onOpenAuth={(*/}
            {/*        authModalMode: AuthModalMode | undefined = undefined,*/}
            {/*    ) => {*/}
            {/*        setCurrentAuthModalMode(authModalMode);*/}
            {/*        setIsAuthOpen(true);*/}
            {/*    }}*/}
            {/*    navItems={nav_items}*/}
            {/*    currentUrl={url}*/}
            {/*/>*/}

            {/*<AuthModal*/}
            {/*    isOpen={isAuthOpen}*/}
            {/*    authModalMode={currentAuthModalMode}*/}
            {/*    onClose={() => setIsAuthOpen(false)}*/}
            {/*/>*/}

            {/*<CartSidebar />*/}

            {/*{alerts && <PageAlert alerts={alerts} />}*/}

            {children}

            {/*<Footer*/}
            {/*    disclaimer={sharedContent?.disclaimer?.text}*/}
            {/*    footerText={sharedContent?.footerText?.text}*/}
            {/*    social={sharedContent?.social}*/}
            {/*    contacts={sharedContent?.contacts}*/}
            {/*    footer={footer}*/}
            {/*/>*/}
        </div>
    );
}

export default Layout;
